import { BoxContainer, ReactIcons, Switch, useThemeContext } from "@kalyzee/kalyzee-ui"

import { Touchable, UserAvatar, useTriggerable } from "@kalyzee/kast-web-sdk/web-components";
import { useAppStoreSelector } from "../../contexts/appStore/selectors";
import { getNormalUser } from "../../helpers/user";
import { useAuthContext } from "@kalyzee/kast-web-sdk";

import styles from "./SettingsWorkBox.module.css";
import workBoxStyles from "./WorkBox.module.css";
import { APP_VERSION } from "../../helpers/utils";
import { usePageContextRef } from "../navigation/PageContext";
import { SessionMode } from "../../contexts/appStore/hooks";
import { useRef } from "react";
import { useSettings } from "../../hooks/settings";

export interface SettingsWorkBoxProps {
  style?: React.CSSProperties;
  className?: string;
  containerRef?: React.RefObject<HTMLDivElement>;
  onClose?: () => void;
}

export const SettingsWorkBox = ({
  style = {},
  className,
  containerRef,
  onClose,
}: SettingsWorkBoxProps) => {
  const user = useAppStoreSelector(state => state.user);
  const authCtx = useAuthContext();
  const themeCtx = useThemeContext();

  const versionRef = useRef<HTMLDivElement>(null);
  const pageContextRef = usePageContextRef<SessionMode.MASTER>();

  const [settings] = useSettings();

  // press 'k' and click 3 times with mouse(left button) on logo
  useTriggerable(versionRef, { clickCount: 3 }, () => pageContextRef.current?.openSettingsPopup());

  return (
    <BoxContainer
      containerRef={containerRef}
      style={style}
      className={className}
      topBarProps={{
        center: [
          <ReactIcons.Settings style={{ width: 31 }} />,
          <span className={workBoxStyles.label}>Paramètres</span>
        ],
      }}
    >
      <div className={styles.container}>
        {user && (
          <>
            <div className={styles.userData}>
              <UserAvatar 
                className={styles.userIcon} 
                mode="image"
                image={user?.identity?.avatar}  
              />
              <div className={styles.userInfo}>
                <div className={styles.userName}>{getNormalUser(user).displayName}</div>
                {user.identity?.email && <div className={styles.userEmail}>{user.identity.email}</div>}
              </div>
            </div>
            <div className={styles.separator} />
          </>
        )}
        <div className={styles.theme}>
          Dark mode
          <Switch 
            className={styles.themeSwitch} 
            value={themeCtx.theme === "dark"}
            onChange={() => themeCtx.setPreferredTheme(themeCtx.theme === "dark" ? "light" : "dark")}
          />
        </div>
        <div className={styles.footer}>
          {settings?.ui?.hideLogoutButton || <Touchable 
            className={styles.logoutBtn}
            onClick={() => authCtx.logout()}
          >
            Se déconnecter
          </Touchable>}
          {APP_VERSION && <div ref={versionRef} className={styles.version}>Version {APP_VERSION}</div>}
        </div>
      </div>
    </BoxContainer>
  );
}